module.exports = __webpack_public_path__ + "static/img/4-EN.dd877ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m/4-EN.png
// module id = 5i4j
// module chunks = 1